import { useFeature } from '@growthbook/growthbook-react';
import * as Ramda from 'ramda';
import { useScopes } from '../../useScopes';
import { usePersona } from '../../usePersona';
import { personaAliases } from '../../../../console/_statics/persona-alias.statics';
import { getPolicyActionsForCowbell } from './cowbell/getPolicyActionsForCowbell';
import { getPolicyActionsForCarrier } from './carrier/getPolicyActionsForCarrier';
import useRenewQuoteFeature from '../../../../console/workflows/renew-quote/useRenewQuoteFeature';
import { FEATURE_FLAG_KEYS } from '../../../../config/growthbook';
import type { PolicyTableInfoDto } from '../../../../types/policy/tables/policy-table-info.dto';
import { PERSONA_TYPES } from '../../../../console/_statics/persona.statics';

export const usePolicyActions = (policy: PolicyTableInfoDto) => {
  const scopes = useScopes();
  const { _legacy_persona, type } = usePersona();

  // Feature flags
  const flatCancelFeature = useFeature(FEATURE_FLAG_KEYS.FLAT_CANCEL);
  const cowbellPolicyGenerateRenewalQuoteFeature = useFeature(
    FEATURE_FLAG_KEYS.COWBELL_GENERATE_RENEWAL_QUOTE
  );

  const undoCancelledPolicyFeature = useFeature(
    FEATURE_FLAG_KEYS.UNDO_CANCELLED_POLICY
  );

  const allowZspCancelFeature = useFeature(FEATURE_FLAG_KEYS.ALLOW_ZSP_CANCEL);
  const primePlusRenewalMigrationFeature = useFeature(
    FEATURE_FLAG_KEYS.PRIME_PLUS_TO_PRIME_ONE_PLUS_US_RENEWAL_MIGRATION
  );

  const renewalsFeature = useRenewQuoteFeature();

  if (
    _legacy_persona === personaAliases.cowbell ||
    _legacy_persona === personaAliases.da ||
    _legacy_persona === personaAliases.cluster
  ) {
    const options = {
      flags: {
        isFlatCancelFeatureOn: flatCancelFeature.on,
        isCowbellPolicyGenerateRenewalQuoteOn:
          cowbellPolicyGenerateRenewalQuoteFeature.on,
        isUndoCancelledPolicyFeatureOn: undoCancelledPolicyFeature.on,
        renewalsFeature: renewalsFeature.on,
        isAllowZspCancelFeatureOn: allowZspCancelFeature.on,
        isPrimePlusRenewalMigrationOn: primePlusRenewalMigrationFeature.on,
      },
    };

    const cowbellPolicyActions = getPolicyActionsForCowbell(
      policy,
      scopes,
      options
    );

    return cowbellPolicyActions;
  }

  if (
    [
      PERSONA_TYPES.CARRIER,
      PERSONA_TYPES.RE_INSURER,
      PERSONA_TYPES.PREMIUM_PROCESSOR,
    ].some(Ramda.equals(type))
  ) {
    const options = { flags: {} };
    const carrierPolicyActions = getPolicyActionsForCarrier(
      policy,
      scopes,
      options
    );

    return carrierPolicyActions;
  }
};
